document.addEventListener('DOMContentLoaded', () => {
    let audatex_fields = document.querySelector('#audatex_estimation_values_form_fields');

    if (audatex_fields !== null) {
        function recalculate_estimation(e) {
            let field_container, subtotal_input, vat_input, total_input, subtotal_amount, vat_amount,
                total_amount;

            field_container = e.closest('.columns');
            subtotal_input = field_container.querySelector('.subtotal');
            vat_input = field_container.querySelector('.vat');
            total_input = field_container.querySelector('.total');

            subtotal_amount = parseFloat(subtotal_input.value.replace(' ', ''));

            if (isNaN(subtotal_amount)) {
                vat_input.value = '0.00';
                total_input.value = '0.00';

            } else {
                subtotal_amount = parseFloat(subtotal_amount.toFixed(2));
                subtotal_input.value = subtotal_amount.toFixed(2);

                vat_amount = parseFloat((subtotal_amount * 0.15).toFixed(2));
                vat_input.value = vat_amount.toFixed(2);

                total_amount = parseFloat((subtotal_amount + vat_amount).toFixed(2));
                total_input.value = total_amount.toFixed(2)
            }

            recalculate_totals()
        }

        function calculate_sums(selector) {
            let sum = 0, value;

            audatex_fields.querySelectorAll(selector).forEach(function (e) {
                value = parseFloat(e.value.replace(' ', ''))
                sum += isNaN(value) ? 0 : value;
            });

            return sum;
        }

        function recalculate_totals() {
            const audatex_subtotal = document.querySelector('#cms_survey_request_audatex_subtotal')
            const audatex_vat = document.querySelector('#cms_survey_request_audatex_vat')
            const audatex_total = document.querySelector('#cms_survey_request_audatex_total')

            audatex_subtotal.value = calculate_sums('.subtotal').toFixed(2);
            audatex_vat.value = calculate_sums('.vat').toFixed(2);
            audatex_total.value = calculate_sums('.total').toFixed(2);
        }

        document.querySelectorAll('input.trigger_calculation').forEach(function (e) {
            e.addEventListener("change", function () {
                recalculate_estimation(e);
            });
        });
    }
});
